// extracted by mini-css-extract-plugin
export default {"badge":"Option-badge_rOTGx"};